const Mode = {
    TEACHER: 'teacher',
    STUDENT: 'student',
};
export default Mode;